import MultiStepsFormDialog, { IMultiStepsFormProps, IStep } from './MultiStepsFormDialog';

export default MultiStepsFormDialog;
export type { IMultiStepsFormProps, IStep };
